import { OptionalAmount } from "../components/Common/dtos/OptionalAmount";
import OrderDto from "../components/Common/dtos/OrderDto";
import { QueryOptions } from "../components/Common/useQuery";
import { useUserOrKaEmployee } from "../components/UserAccess/useUserOrKaEmployee";
import usePaginatedQuery, { PaginatedResult, PaginationParams } from "./usePaginatedQuery";

export interface OrderDisplayDto extends OrderDto {
  customerName: string;
  customerAccountNumber: string;
  totalRequested: OptionalAmount;
  totalDispensed: OptionalAmount;
  siteNames: string[];
  createdAt: string;
  completedAt?: string;
}

export interface OrderPaginationParams extends PaginationParams {
  completed: boolean;
  orderNumberFilter?: string;
  itemId?: string;
  siteId?: string;
  customerId?: string;
  startDate?: string;
  endDate?: string;
}

const useGetOrders = (
  params: OrderPaginationParams,
  options?: QueryOptions<PaginatedResult<OrderDisplayDto>>
) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  const baseUrl = `/api/businesses/${selectedBusiness?.id}/orders`;

  return usePaginatedQuery<OrderDisplayDto>(baseUrl, params, options);
};

export default useGetOrders;